export default "__VITE_ASSET__CwWYttyH__"